import { BancoResolver } from './banco.resolver';
import { ContratoPorIdResolver } from './contrato-por-id-resolver';
import { ContratosResolver } from './contratos.resolver';
import { ComissionamentosPorIdResolver } from './comissionamento-por-id-resolver';
import { ComissionamentosResolver } from './comissionamento-resolver';
import { ContaCorrentePorIdIdResolver } from './conta-corrente-por-id.resolver';
import { ContasCorrenteResolver } from './contas-corrente.resolver';
import { ExtratoLancamentoCreditoResolver } from './extrato-lancamentos-credito.resolver';
import { FormaPagamentoResolver } from './forma-pagamento.resolver';
import { GrupoLancamentoResolver } from './grupo-lancamento.resolver';
import { ItemsResolver } from './items.resolver';
import { LancamentoPorIdResolver } from './lancamento-por-id.resolver';
import { MensalidadeAssociativaPorIdResolver } from './mensalidade-associativa-por-id.resolver';
import { ModoPagamentoPorIdResolver } from './modo-pagamento-por-id.resolver';
import { PessoaArquivoPorIdResolver } from './pessoa-arquivo-por-id.resolver';
import { PessoaEnderecoPorIdResolver } from './pessoa-endereco-por-id.resolver';
import { PessoaOcorrenciaPorIdResolver } from './pessoa-ocorrencia-por-id.resolver';
import { PessoaPorIdResolver } from './pessoa-por-id.resolver';
import { PessoaResolver } from './pessoa.resolver';
import { ProdutoPrecoResolver } from './produto-preco.resolver';
import { ProdutosPorIdResolver } from './produtos-por-id.resolver';
import { ProdutosResolver } from './produtos.resolver';
import { ShoppingCartModoPagamentoContaResolver } from './shopping-cart-modo-pagamento-conta.resolver';
import { TipoDeLancamentoPorIdResolver } from './tipo-de-lancamento-por-id.resolver';
import { TipoDeLancamentoResolver } from './tipo-de-lancamento.resolver';
import { HorarioTrabalhoFuncionarioResolver } from './horario-trabalho-funcionario.resolver';
import { TipoContratoFuncionarioPorIdResolver } from './tipo-contrato-funcionario-por-id.resolver';
import { TipoContratoFuncionarioResolver } from './tipo-contrato-funcionario.resolver';
import { HorarioTrabalhoFuncionarioPorIdResolver } from './horario-trabalho-funcionario-por-id.resolver';
import { EstadoCivilResolver } from './estado-civil.resolver';
import { EstadoCivilPorIdResolver } from './estado-civil-por-id.resolver';
import { PessoaFuncionarioPorIdResolver } from './pessoa-funcionario-por-id.resolver';
import { FormaPagamentoPorIdResolver } from './forma-pagamento-por-id.resolver';
import { ModoPagamentoPorPorCnpjResolver } from './modo-pagamento-por-cnpj.resolver';

export const FinanceiroResolver = [
  BancoResolver,
  ComissionamentosPorIdResolver,
  ComissionamentosResolver,
  ContaCorrentePorIdIdResolver,
  ContasCorrenteResolver,
  ContratoPorIdResolver,
  ContratosResolver,
  ExtratoLancamentoCreditoResolver,
  EstadoCivilResolver,
  EstadoCivilPorIdResolver,
  FormaPagamentoPorIdResolver,
  FormaPagamentoResolver,
  GrupoLancamentoResolver,
  HorarioTrabalhoFuncionarioResolver,
  HorarioTrabalhoFuncionarioPorIdResolver,
  ItemsResolver,
  LancamentoPorIdResolver,
  MensalidadeAssociativaPorIdResolver,
  ModoPagamentoPorPorCnpjResolver,
  ModoPagamentoPorIdResolver,
  PessoaResolver,
  PessoaPorIdResolver,
  PessoaArquivoPorIdResolver,
  PessoaEnderecoPorIdResolver,
  PessoaFuncionarioPorIdResolver,
  PessoaOcorrenciaPorIdResolver,
  ProdutoPrecoResolver,
  ProdutosPorIdResolver,
  ProdutosResolver,
  ShoppingCartModoPagamentoContaResolver,
  TipoDeLancamentoPorIdResolver,
  TipoDeLancamentoResolver,
  TipoContratoFuncionarioResolver,
  TipoContratoFuncionarioPorIdResolver,

]
